import React from 'react';
import IconToolTip from '../../../../common/IconToolTip';
import { Accordion, AccordionDetails, AccordionSummary } from '../../../project/reusableComponents/AccordianForTeams';
import { RenderHeader } from '.';


export const RenderKycDetails = ({ user, kyc, expanded, handleChange }) => {

    if (kyc && kyc.length > 0) {
        return <>
            <Accordion expanded={expanded === 'panel4'} onChange={handleChange('panel4')} elevation={0}>
                <AccordionSummary expandIcon={<span className='material-icons text-scogobgsky'> expand_more </span>} aria-controls='panel1bh-content' id='panel1bh-header'>
                    <RenderHeader isVerfied={user.is_verified} title="KYC Details" />
                </AccordionSummary>
                <AccordionDetails>
                    <div className='px-6'>
                        {kyc.map(({ label, value, files }) => {
                            return <p className='flex items-center gap-2 font-normal py-2'>
                                <span className={'capitalize text-font11 text-scogogray'}>{label}</span>
                                <p className='max-w-max truncate scogoprimary text-font10 font-medium flex items-center rounded-3px'>{value}</p>
                                {files && files.length > 0 && files.map(({ link }) => {
                                    return <IconToolTip title='Document URL'>
                                        <span className='material-icons hover:text-scogoorange cursor-pointer text-font11 text-scogoprimary' onClick={() => window.open(link, '_blank')}>
                                            visibility
                                        </span>
                                    </IconToolTip>
                                })}
                            </p>
                        })}

                    </div>
                </AccordionDetails>
            </Accordion>
        </>

    }
    return <></>;
};